import React from 'react';
import { LoadingSpinner } from '../../../../../../../../../components/LoadingSpinner';
import { PendingExecutionsAlert } from './PendingExecutionsAlert';
import { CandidateEmailsList } from './CandidateEmailsList';
import { ButtonsRow } from './ButtonsRow';

interface PropTypes {
  isLoading: boolean;
  isLoadingMore: boolean;
  error: string | null;
  candidateEmails: string[];
  entriesCount: number;
  totalCount: number;
  hasMore: boolean;
  search: string;
  onSearchChange: (value: string) => void;
  onLoadMore: () => Promise<void>;
  onCancel: () => void;
  onContinue: () => void;
}

export function ModalBody(props: PropTypes) {
  if (props.isLoading && props.candidateEmails.length === 0) {
    return <LoadingSpinner minHeight='100px' />;
  }

  if (props.error && props.candidateEmails.length === 0) {
    return <div className='text-danger'>{props.error}</div>;
  }

  return (
    <>
      <PendingExecutionsAlert totalCount={props.totalCount} />
      <CandidateEmailsList
        candidateEmails={props.candidateEmails}
        entriesCount={props.entriesCount}
        hasMore={props.hasMore}
        isLoadingMore={props.isLoadingMore}
        search={props.search}
        onSearchChange={props.onSearchChange}
        onLoadMore={props.onLoadMore}
      />
      <ButtonsRow onCancel={props.onCancel} onContinue={props.onContinue} />
    </>
  );
}
